import React, { useEffect, useState } from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, BarChart, Bar, Cell
} from 'recharts';

const API_URL = '';

export default function VisitorAnalyticsPanel() {
  const [data, setData] = useState({ daily: [], pages: [], total: 0, today: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchAnalytics(); }, []);

  const fetchAnalytics = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/api/admin/analytics/visitors`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const json = await res.json();
      setData(json);
    } catch (err) {
      console.error('Analytics error:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div style={styles.center}>
      <p style={{ color: '#fff' }}>Loading analytics...</p>
    </div>
  );

  const COLORS = ['#ce0021', '#ff6b35', '#4ecdc4', '#95e1d3', '#f7dc6f'];

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Visitor Analytics</h2>
        <button style={styles.refreshBtn} onClick={fetchAnalytics}>🔄 Refresh</button>
      </div>

      <div style={styles.cardRow}>
        <div style={styles.card}>
          <span style={styles.cardIcon}>👥</span>
          <h3 style={{ ...styles.cardValue, color: '#4ecdc4' }}>{data.total?.toLocaleString()}</h3>
          <p style={styles.cardLabel}>Total Visitors</p>
        </div>
        <div style={styles.card}>
          <span style={styles.cardIcon}>📈</span>
          <h3 style={{ ...styles.cardValue, color: '#ce0021' }}>{data.today?.toLocaleString()}</h3>
          <p style={styles.cardLabel}>Visits Today</p>
        </div>
      </div>

      <div style={styles.chartBox}>
        <h3 style={styles.chartTitle}>Visits — Last 7 Days</h3>
        {data.daily?.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={data.daily}>
              <CartesianGrid strokeDasharray="3 3" stroke="#333" />
              <XAxis dataKey="date" stroke="#999" tick={{ fontSize: 12 }}
                tickFormatter={d => d?.slice(5)} />
              <YAxis stroke="#999" tick={{ fontSize: 12 }} />
              <Tooltip
                contentStyle={{ background: '#1a1a1a', border: '1px solid #ce0021', borderRadius: 8 }}
                labelStyle={{ color: '#fff' }}
                itemStyle={{ color: '#ce0021' }}
              />
              <Line type="monotone" dataKey="visits" stroke="#ce0021"
                strokeWidth={3} dot={{ fill: '#ce0021', r: 5 }} activeDot={{ r: 7 }} />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <p style={styles.empty}>No visit data yet — visits will appear once your site gets traffic.</p>
        )}
      </div>

      <div style={styles.chartBox}>
        <h3 style={styles.chartTitle}>Top Pages</h3>
        {data.pages?.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={data.pages}>
              <CartesianGrid strokeDasharray="3 3" stroke="#333" />
              <XAxis dataKey="path" stroke="#999" tick={{ fontSize: 11 }} />
              <YAxis stroke="#999" tick={{ fontSize: 12 }} />
              <Tooltip
                contentStyle={{ background: '#1a1a1a', border: '1px solid #ce0021', borderRadius: 8 }}
                labelStyle={{ color: '#fff' }}
              />
              <Bar dataKey="visits" radius={[6, 6, 0, 0]}>
                {data.pages.map((_, i) => (
                  <Cell key={i} fill={COLORS[i % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p style={styles.empty}>No page data yet.</p>
        )}
      </div>
    </div>
  );
}

const styles = {
  container: { padding: '30px', backgroundColor: '#0a0a0a', minHeight: '100vh', color: '#fff' },
  center: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '30px' },
  title: { fontSize: '28px', fontWeight: 'bold', color: '#ce0021', margin: 0 },
  refreshBtn: { padding: '10px 20px', background: 'rgba(206,0,33,0.1)', border: '1px solid rgba(206,0,33,0.3)', borderRadius: '8px', color: '#ce0021', cursor: 'pointer', fontSize: '14px', fontWeight: '600' },
  cardRow: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' },
  card: { background: 'linear-gradient(135deg, #1a1a1a, #0f0f0f)', border: '1px solid rgba(206,0,33,0.2)', borderRadius: '16px', padding: '24px', textAlign: 'center' },
  cardIcon: { fontSize: '32px' },
  cardValue: { fontSize: '36px', fontWeight: 'bold', margin: '8px 0' },
  cardLabel: { color: '#999', fontSize: '14px', margin: 0 },
  chartBox: { background: 'linear-gradient(135deg, #1a1a1a, #0f0f0f)', border: '1px solid rgba(206,0,33,0.2)', borderRadius: '16px', padding: '24px', marginBottom: '24px' },
  chartTitle: { fontSize: '18px', fontWeight: 'bold', color: '#fff', marginBottom: '20px', borderLeft: '4px solid #ce0021', paddingLeft: '12px' },
  empty: { color: '#666', textAlign: 'center', padding: '40px 0', fontStyle: 'italic' }
};